import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from '@piplapps/pipl-ui';
import styles from './RenameTeamModal.module.less';
import LoadingButton from '../../../Components/LoadingButton';
import AnalyticsHandler from '../../../Utils/AnalyticsHandler/AnalyticsHandler';
import AnalyticsEventNames from '../../../Utils/AnalyticsHandler/AnalyticsEventNames';
import { UsersActions } from '../../../Redux/modules/users/actions';

const DeleteTeam = (props) => {
  const { userData } = props;

  return (
    <div className={styles.modalContainer}>
      <div className={styles.header}>{props.title}</div>
      <span
        tabIndex={0}
        role="button"
        className={styles.close}
        onClick={() => {
          props.clickedCloseModalButton();
        }}
      >
        &times;
      </span>
      <div className={styles.text}>
        {gettext('Are you sure you want to permanently remove the team ')}
        <strong>{gettext(` ${userData.name}`)}</strong>
        {gettext('? Performing this action, all users will be unassigned from this team.')}
      </div>

      <div className={styles.buttonContainer}>
        <div className={styles.buttonWrapper}>
          <AnalyticsHandler
            eventName={AnalyticsEventNames.DELETE_TEAM}
            eventData={{ teamName: userData.name, teamId: userData.id }}
          >
            <LoadingButton
              id="submit-button"
              buttonClass="primary-red"
              type="submit"
              onClick={() => props.onDeleteTeam(userData.id)}
              text={gettext('Delete team')}
            />
          </AnalyticsHandler>
        </div>
        <div className={styles.buttonWrapper}>
          <Button
            buttonClass="secondary-blue"
            onClick={() => props.clickedCloseModalButton()}
            text={gettext('Cancel')}
            id="cancel-button"
          />
        </div>
      </div>
    </div>
  );
};

DeleteTeam.propTypes = {
  userData: PropTypes.object,
  title: PropTypes.string,
  onDeleteTeam: PropTypes.func,
  clickedCloseModalButton: PropTypes.func,
};

const mapDispatchToProps = {
  clickedCloseModalButton: UsersActions.clickedCloseModalButton,
  onDeleteTeam: UsersActions.deleteTeam,
};

export default connect(null, mapDispatchToProps)(DeleteTeam);
